import React from "react";
import { useSalesPersons } from "../../hooks/usePersonsData";
import { useUpdateNextActionMutation } from "../../store/services/nextActionService";
import { WorkItemList } from "../../store/services/timelineApiRTK";
import AssignPersonDialog from "./AssignPersonDialog";

interface AssignWorkItemDialogProps {
  open: boolean;
  onClose: () => void;
  workItem: WorkItemList;
}

const AssignWorkItemDialog: React.FC<AssignWorkItemDialogProps> = ({
  open,
  onClose,
  workItem,
}) => {
  const { persons, isLoading } = useSalesPersons();
  const [updateWorkItem] = useUpdateNextActionMutation();

  const handleAssign = async (personId: number | null) => {
    try {
      await updateWorkItem({
        customerNo: workItem.Customer.Id,
        request: {
          scheduledDate: workItem.ScheduledTo,
          title: workItem.Name,
          description: workItem.Description,
          teamId: workItem.Team?.Id,
          assignedToId: personId ?? undefined, // Detta är det som ändras
          externalId: workItem.ExternalId,
          workNo: workItem.WorkId ?? undefined,
          type: workItem.Type,
          workItemNo: workItem.Id,
        },
      }).unwrap();
    } catch (error) {
      console.error("Error assigning work item:", error);
      throw error;
    }
  };

  return (
    <AssignPersonDialog
      open={open}
      onClose={onClose}
      title="Tilldela aktivitet"
      label="Tilldela till"
      currentPersonId={workItem.AssignedTo?.Id}
      persons={persons}
      isLoading={isLoading}
      onAssign={handleAssign}
      allowClear={true}
      clearLabel="Ej tilldelad"
    />
  );
};

export default AssignWorkItemDialog;
